import { IAppError } from './IAppError';

export abstract class BaseDomainError extends Error implements IAppError {
  abstract readonly code: string;
  readonly layer: IAppError['layer'] = 'domain';
  readonly suggestions: { ux: string[]; dx: string[] };
  readonly cause?: unknown;

  protected constructor(
    message: string,
    suggestions: { ux: string[]; dx: string[] },
    cause?: unknown
  ) {
    super(message);
    this.name = new.target.name;
    this.suggestions = suggestions;
    this.cause = cause;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}